import React, {Component} from "react";
import ReactDOM from "react-dom";
import Overlay from '../../components/Overlay'
import { Helmet } from 'react-helmet'
import { compose, lifecycle, withState } from 'recompose'
import { injectIntl } from 'react-intl'
import { checkPhone } from './../Signin'


export const Skolkovo = ({success, setSuccess}) => {
  let self = this

  let contentSuccess = `
	<div style="padding-top:16px; padding-left:25px; padding-right:25px; position:relative; z-index:3; font-family:Arial; color:#ff5027; ">
        <div class="modal_dr_2" style="color: white" >С вами помогать - одно удовольствие!</div>    
    </div>
`

  function validatePhone () {
    if (!(document.form.phone.value)) {
      document.getElementById('errorPhone').innerHTML = 'Номера телефона - обязательное поле<br>';
    } else if (!checkPhone(document.form.phone.value)) {
  	  document.getElementById('errorPhone').innerHTML = 'Неверный формат номера телефона<br>';
    } else {
  	  document.getElementById('errorPhone').innerHTML = '';
    }
  }

  function validateName () {
  if (!document.form.name.value) {
  	document.getElementById('errorName').innerHTML = 'Имя - обязательное поле для ввода<br>';
    } else {
  	  document.getElementById('errorName').innerHTML = '';
    }
  }

  function validateSum () {
  if (document.form.sum.value < 100) {
  	document.getElementById('errorSum').innerHTML = 'Минимальная сумма для пожертвования - 100 рублей<br>';
    } else {
  	  document.getElementById('errorSum').innerHTML = '';
    }
  }
  
  function validateCheck () {
    if (!document.form.agreement.checked) {
  	  document.getElementById('errorCheck').innerHTML = 'Необходимо согласие с условиями публичной оферты<br>';
    } else {
  	  document.getElementById('errorCheck').innerHTML = '';
    }
  }
  
  function cloudPay(name, sum, phone) {
    name = document.form.name.value;
    sum = document.form.sum.value;
    phone = document.form.phone.value;
    let agreement = document.form.agreement.checked;
  
    if (agreement && (sum >= 100) && phone && checkPhone(phone)) {
      var widget = new window.cp.CloudPayments();
      widget.charge({ // options
          publicId: 'pk_3b2cdf2787d8d694a20d76d7edde3',  //publicId AHO
          description: 'Пожертвование АНО "Мит Фор Черити" на уставные цели (ИНН 9702014610)',//назначение
          amount: Number(sum),//10, //сумма
          currency: 'RUB', //валюта
          invoiceId: '1234567', //номер заказа  (необязательно)
          accountId: name,//'user@example.com', //идентификатор плательщика (необязательно)
          skin: "mini", //дизайн виджета
          phone: phone,
          data: {
            donate: true, //атрибут пожертвования, по нему будет отменяться обработка ответа с CP по успешной/неуспешной оплате
            phone: phone
          }
        },
        function (options) { // success
          setSuccess(true)
              setTimeout(() => {
                //setSuccess(undefined)
                var win = window.open('/', '_self')
                win.focus()
              }, 5000)
          return (true)
        },
        function (reason, options) { // fail
        });
    } else {
      if (sum < 100) {
        document.getElementById('errorSum').innerHTML = 'Минимальная сумма для пожертвования - 100 рублей<br>';
      }
      if (!agreement) {
        document.getElementById('errorCheck').innerHTML = 'Необходимо согласие с условиями публичной оферты<br>';
      }
      //if (!name) {
      //  document.getElementById('errorName').innerHTML = 'Имя - обязательное поле<br>';
      //}
      if (!phone) {
        document.getElementById('errorPhone').innerHTML = 'Номера телефона - обязательное поле<br>';
      } else if (!checkPhone(phone)) {
        document.getElementById('errorPhone').innerHTML = 'Неверный формат номера телефона<br>';
      }
    }
  }

  return (
  <div className='Container Container_light'>
  <div className='Donate mfc-modal_2'>
    <Helmet>
      <title>Пожертвовать MFC</title>
    </Helmet>
    <Overlay isActive={true} klassModifier={"mfc-modal_3"}> 
	{/*style={{ backgroundImage: 'url("/assets/img/misc/celebration_bottle.jpg")',
	   backgroundPosition: 'right bottom',
  backgroundRepeat: 'no-repeat'}}*/}
    
      <div className="mfc-modal-content donate">
        <form name='form'>
        <div className="mfc-modal__input-wrapper">
          <label htmlFor="name">Имя</label>
          <input
            className='mfc-modal__input'
            //onChange={validateName}
            type="text"
            name="name"
            id="name"
            placeholder=""
          />
        </div>

        <div className="mfc-modal__input-wrapper">
          <label htmlFor="phone">Телефон</label>
          <input
            className='mfc-modal__input'
            onChange={validatePhone}
            type="tel"
            name="phone"
            id="phone"
            placeholder=""
            min="0"
            required
          />
        </div>

        <div className="mfc-modal__input-wrapper">
          <label htmlFor="sum">Сумма пожертвования в пользу MeetForCharity</label>
          <input
            className='mfc-modal__input'
            type="number"
            name="sum"
            id="sum"
            min="100"
			onChange={validateSum}
			required
          />
        </div>

        <div className="mfc-modal__checkbox-wrapper">
          <div className="checkbox">
            <input className="custom-checkbox" type="checkbox" id="color-1" name="agreement" value="indigo" onChange={validateCheck} />
              <label htmlFor="color-1">Согласен с условиями&nbsp;
                <a href="/skolkovo/offer" target="_blank" className="mfc-modal__link">
                  публичной оферты
                </a>
              </label>
          </div>
          <span id='errorPhone' className='error'></span>
          <span id='errorSum' className='error'></span>
          <span id='errorCheck' className='error'></span>
        </div>
	
          <a className='mfc-modal__btn-submit' onClick={cloudPay}>Помогаю!</a>
        </form>
        <div className="mfc-modal__thanks">
          <b>Спасибо!</b><br />
          #КаждаяВстречаИмеетЗначение
        </div>
        <div className="mfc-modal__logo-list">
          <div className="Header__logo-img">
            <a href="https://meetforcharity.today/" alt="meetforcharity.today" title="meetforcharity.today">
	      <svg xmlns="http://www.w3.org/2000/svg" width="216" height="28" viewBox="0 0 216 40">
                <g fill="white" fillRule="evenodd">
                  <path d="M0 18.769h3.956l2.945 8.678 2.873-8.678h3.868v12.635h-2.608v-8.979L7.93 31.404H5.783l-3.14-8.89v8.89H0zM19.77 23.81c-1.119 0-1.899.78-2.041 2.057h4.009c-.106-1.117-.71-2.058-1.969-2.058m.089 7.861c-2.82 0-4.683-1.916-4.683-4.791 0-2.84 1.933-4.898 4.594-4.898 2.768 0 4.524 2.023 4.524 5.236v.248h-6.564c.035 1.58.798 2.43 2.146 2.43.923 0 1.49-.407 1.863-1.33h2.412c-.567 1.987-2.217 3.105-4.292 3.105m10.37-7.86c-1.118 0-1.898.78-2.04 2.057h4.008c-.106-1.117-.709-2.058-1.968-2.058m.088 7.861c-2.82 0-4.683-1.916-4.683-4.791 0-2.84 1.934-4.898 4.595-4.898 2.767 0 4.523 2.023 4.523 5.236v.248h-6.563c.035 1.58.798 2.43 2.146 2.43.923 0 1.49-.407 1.862-1.33h2.413c-.567 1.987-2.217 3.105-4.293 3.105m10.91-7.719h-1.863v4.312c0 .887.018 1.296 1.1 1.296.266 0 .461 0 .763-.036v1.917c-.692.053-.958.07-1.526.07-2.164 0-2.838-.567-2.838-2.803v-4.756h-1.526v-1.703h1.526V19.48h2.501v2.768h1.863v1.703zM57.484 13.31H46.746v6.376h9.475v2.269h-9.475v9.449h-2.699V10.955h13.437zM61.266 23.994c0 3.648 1.751 5.802 4.737 5.802 2.87 0 4.594-2.183 4.594-5.83 0-3.533-1.78-5.773-4.651-5.773-2.872 0-4.68 2.268-4.68 5.801m11.828-.086c0 5.026-2.612 7.956-7.12 7.956-4.536 0-7.235-2.93-7.235-7.812 0-4.883 2.785-7.898 7.264-7.898s7.091 2.843 7.091 7.754m10.623-5.141c-.259-.029-.373-.029-.632-.029-4.02 0-4.737 3.074-4.737 6.405v6.261h-2.44v-14.82h2.325v3.188c1.033-2.498 2.842-3.533 5.484-3.533v2.528zm17.142 13.326c-8.484 0-14.039-6.29-14.039-15.982 0-8.616 4.995-16.11 14.297-16.11 5.9 0 11.843 3.704 12.532 9.95h-2.928c-.948-4.566-4.694-7.41-9.69-7.41-6.804 0-11.325 5.429-11.325 13.57 0 8.142 4.435 13.484 11.24 13.484 6.158 0 9.56-4.222 10.206-9.952h2.885c-.646 7.583-5.814 12.45-13.178 12.45m19.81-18.653c1.593-3.187 4.005-4.738 7.665-4.738 5.168 0 7.752 2.972 7.752 8.056v14.646h-2.713V17.102c0-3.79-1.766-6.117-5.684-6.117-5.04 0-6.977 3.963-6.977 8.745v11.674h-2.67V.732h2.67c0 13.398 0 11.028-.043 12.708m28.723 7.453c-2.8.387-6.589 1.034-6.589 4.653 0 2.584 1.981 4.221 5.082 4.221 4.048 0 7.536-2.585 7.536-6.806v-3.619c-.861.948-3.057 1.163-6.029 1.55zm11.197 10.382c-.732.258-1.378.345-2.153.345-2.627 0-2.886-2.025-2.886-4.05-1.808 2.886-4.607 4.437-8.354 4.437-4.522 0-7.235-2.326-7.235-6.203 0-4.05 2.756-6.29 8.225-6.85 3.488-.344 5.383-.43 6.46-1.162.56-.388.775-.991.775-2.111 0-3.662-2.24-4.782-5.77-4.782-3.747 0-5.685 1.637-6.03 5.212h-2.583c.215-4.739 3.445-7.452 8.914-7.452 4.996 0 8.14 2.196 8.14 6.375v12.062c0 1.336-.044 2.24 1.464 2.24.344 0 .56 0 1.033-.129v2.068zm14.254-19.6c-.302 0-.56-.044-.732-.044-3.316 0-6.201 2.068-7.062 5.255-.345 1.336-.517 2.628-.517 5.471v9.047h-2.67V9.262h2.54v5.298c1.852-4.049 3.962-5.556 8.441-5.643v2.757zm2.282 19.729h2.713V9.262h-2.713v22.142zm0-26.364h2.713V.603h-2.713V5.04zm16.752 6.419h-4.565v14.043c0 2.24-.086 3.705 2.8 3.705.473 0 .99-.043 1.765-.129v2.326c-.99.13-1.421.172-2.368.172-1.938 0-4.092-.388-4.608-2.541-.216-.905-.259-1.55-.259-4.868V11.459h-3.918V9.262h3.918V2.499h2.67v6.763h4.565v2.197zm12.445 20.763c-1.938 5.17-2.97 7.583-6.545 7.583-.819 0-1.594-.087-2.369-.216v-2.37c1.034.26 1.335.302 1.938.302 2.627 0 3.359-2.628 4.737-6.29l-8.914-21.969h2.97l5.987 15.25c.775 2.025.474 1.292 1.335 3.92.69-2.24.947-3.188 1.335-4.222l5.47-14.948h2.756l-8.7 22.96z"/>
                </g>
              </svg>
              <img src="" width="60" alt="BFC" className="logo-item-small" />
            </a>
          </div>
        </div>
      </div>
    </Overlay>

    {(success === true) && <Overlay isActive={true}>
      <div dangerouslySetInnerHTML={{__html: contentSuccess}} />	
    </Overlay>}

  </div>
  </div>
)
}

export default injectIntl(compose(
  withState('success', 'setSuccess', undefined),
)(Skolkovo))


// WEBPACK FOOTER //
// ./src/containers/Donate/Skolkovo.jsx